import { ListItemResponse, ResponseDropDownList } from "./response";

const formatDropDownList = ({ response }: { response: ResponseDropDownList }) => {

    const row = !response.errors
        ? response?.items.map((item) => {
            return {
                id: item.id,
                name: item.name,
                valuesCount: item.valuesCount,
                relationsCount: item.relationsCount
            }
        })
        : []

    return {
        row
    }
}

const formatItemList = ({ response }: { response: ListItemResponse }) => {

    const name = response.name;
    const items = response.children.map((item)=>{
        return {
            id: item.id,
            value: item.name
        }
    })

    return {
        name,
        items
    }
}

export { formatDropDownList, formatItemList }